import React from 'react'
import ReactDOM from 'react-dom'

import styles from './styles.module.css'

interface ToastProps {
  children: React.ReactNode
}

const Toast = ({ children }: ToastProps) => {
  return ReactDOM.createPortal(<div className={styles.toast}>{children}</div>, document.body)
}

export default Toast
